"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.playBlob = void 0;
let _audio = null;
let _url = null;
function playBlob(blob) {
    return __awaiter(this, void 0, void 0, function* () {
        if (_audio) {
            try {
                _audio.pause();
            }
            catch (_a) { }
        }
        if (_url) {
            URL.revokeObjectURL(_url);
            _url = null;
        }
        _url = URL.createObjectURL(blob);
        _audio = new Audio(_url);
        yield _audio.play();
        _audio.onended = () => {
            if (_url)
                URL.revokeObjectURL(_url);
            _url = null;
            _audio = null;
        };
    });
}
exports.playBlob = playBlob;
